import { useState } from 'react'

// A hook that keeps a piece of state in sync with an initial value from props, it allows
// to handle a local state that resets when the prop changes.
const useLocalState = <StateType, PropType = StateType>(
	initialValueFromProps: PropType,
	transformPropsToState?: (props: PropType) => StateType
) => {
	const [value, setValue] = useState(
		transformPropsToState
			? transformPropsToState(initialValueFromProps)
			: (initialValueFromProps as unknown as StateType)
	)
	const [previousInitialValueFromProps, setPreviousInitialValueFromProps] =
		useState(initialValueFromProps)
	if (initialValueFromProps !== previousInitialValueFromProps) {
		setPreviousInitialValueFromProps(initialValueFromProps)
		setValue(
			transformPropsToState
				? transformPropsToState(initialValueFromProps)
				: (initialValueFromProps as unknown as StateType)
		)
	}
	return [value, setValue] as const
}

export { useLocalState }
